const defaultRouters = [{
  path: '*',
  redirect: '/err'
},
{
  path: '/',
  redirect: '/home'
},
{
  name: 'home',
  component: () =>
      import('../view/home'),
  meta: {
    title: '访客管理系统',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'err',
  component: () =>
      import('../view/Error'),
  meta: {
    title: '访客管理系统'
  }
},
{
  name: 'wx_login',
  component: () =>
      import('../view/home/wx_login.vue'),
  meta: {
    title: '微信登陆'
  }
},
{
  name: 'user',
  component: () =>
      import('../view/user'),
  meta: {
    title: '访客管理系统',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'qrCode',
  component: () =>
      import('../view/home/qrCode'),
  meta: {
    title: '二维码'
  }
},
{
  name: 'personalData',
  component: () =>
      import('../view/user/personalData'),
  meta: {
    title: '个人资料',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'history',
  component: () =>
      import('../view/user/history'),
  meta: {
    title: '访客历史记录',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'staffHistory',
  component: () =>
      import('../view/user/history/staffHistory'),
  meta: {
    title: '员工历史记录',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'historyDetail',
  component: () =>
      import('../view/user/history/historyDetail'),
  meta: {
    title: '访客历史记录详情',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'staffHistoryDetail',
  component: () =>
      import('../view/user/history/staffHistoryDetail'),
  meta: {
    title: '员工历史记录详情',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'meeting',
  component: () =>
      import('../view/user/meetingHistory'),
  meta: {
    title: '访客会议记录',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'staffMeetingHistory',
  component: () =>
      import('../view/user/meetingHistory/staffHistory'),
  meta: {
    title: '员工会议记录',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'staffMeetingHistoryDetail/:id/:activeName',
  component: () =>
      import('../view/user/meetingHistory/staffHistoryDetail'),
  meta: {
    title: '员工会议记录详情',
    requireAuth: true// 判断是否需要登录
  }
},{
  name: 'meetingHistoryDetail/:id/:activeName',
  component: () =>
      import('../view/user/meetingHistory/staffHistoryDetail'),
  meta: {
    title: '员工会议记录详情'
    // requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'attendees',
  component: () =>
      import('../view/user/meetingHistory/attendees'),
  meta: {
    title: '参会者',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'requires',
  component: () =>
      import('../view/user/meetingHistory/requires'),
  meta: {
    title: '会务要求',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'systemSetting',
  component: () =>
      import('../view/user/systemSetting'),
  meta: {
    title: '设置',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'aboutUs',
  component: () =>
      import('../view/user/systemSetting/aboutUs'),
  meta: {
    title: '关于我们',
    requireAuth: true
  }
}, {
  name: 'privacyGuide',
  component: () =>
      import('../view/user/systemSetting/privacyGuide'),
  meta: {
    title: '康塔隐私保护指引',
    requireAuth: true
  }
}, {
  name: 'invitations',
  component: () =>
      import('../view/user/invitations/invitations'),
  meta: {
    title: '邀请函',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'bind',
  component: () =>
      import('../view/user/bind'),
  meta: {
    title: '绑定用户',
    requireAuth: true// 判断是否需要登录
  }
},{
  name: 'bindByPhone',
  component: () =>
      import('../view/user/bindByPhone'),
  meta: {
    title: '绑定用户',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'guide',
  component: () =>
      import('../view/home/guide'),
  meta: {
    title: '保护指引',
    requireAuth: true
  }
},
{
  name: 'invite',
  component: () =>
      import('../view/home/invite'),
  meta: {
    title: '邀约访客',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'appointmentSuc',
  component: () =>
      import('../view/home/appointmentSuc'),
  meta: {
    title: '预约成功',
    requireAuth: true
  }
},
{
  name: 'unverified',
  component: () =>
      import('../view/home/invite/unverified'),
  meta: {
    title: '邀约访客',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'match',
  component: () =>
      import('../view/home/invite/match'),
  meta: {
    title: '员工认证',
    requireAuth: true// 判断是否需要登录
  }
}, {
  name: 'unmatch',
  component: () =>
      import('../view/home/invite/unmatch'),
  meta: {
    title: '员工认证-未匹配',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'inviteSuc',
  component: () =>
      import('../view/home/invite/inviteSuc'),
  meta: {
    title: '邀约成功',
    requireAuth: true
  }
},
{
  name: 'faceAuth',
  component: () =>
      import('../view/home/faceAuth'),
  meta: {
    title: '人脸验证'
  }
},
{
  name: 'passCode',
  component: () =>
      import('../view/user/passCode/passCode'),
  meta: {
    title: '通行二维码',
    requireAuth: true// 判断是否需要登录
  }
},
{
  name: 'meetingBook',
  component: () =>
      import('../view/user/meetingBook/meetingBook'),
  meta: {
    title: '会议预约',
    keepAlive: true
  }
},
{
  name: 'roomInfo',
  component: () =>
      import('../view/user/meetingBook/roomInfo'),
  meta: {
    title: '会议详情',
    requireAuth: true
  }
},
{
  name: 'addOthers',
  component: () =>
      import('../view/user/meetingBook/addOthers'),
  meta: {
    title: '添加外部参会人',
    requireAuth: true
  }
},
{
  name: 'addHost',
  component: () =>
      import('../view/user/meetingBook/addHost'),
  meta: {
    title: '添加联系人',
    requireAuth: true
    // keepAlive: true
  }
},
{
  name: 'addStaff',
  component: () =>
      import('../view/user/meetingBook/addStaff'),
  meta: {
    title: '添加内部参会人',
    requireAuth: true
    // keepAlive: true
  }
},
{
  name: 'addMaterials',
  component: () =>
      import('../view/user/meetingBook/addRequires'),
  meta: {
    title: '选择会务要求',
    requireAuth: true
  }
},
{
  name: 'pickedStaff',
  component: () =>
      import('../view/user/meetingBook/pickedStaff'),
  meta: {
    title: '已选择参会人',
    requireAuth: true
  }
},
{
  name: 'bookSuccess',
  component: () =>
      import('../view/user/meetingBook/bookSuccess'),
  meta: {
    title: '预约成功',
    requireAuth: true
  }
},
{
  name: 'attendanceRecord',
  component: () =>
      import('../view/user/attendanceRecord/attendanceRecord'),
  meta: {
    title: '考勤记录',
    requireAuth: true
  }
},
{
  name: 'changeFloor',
  component: () =>
      import('../view/user/history/changeFloor'),
  meta: {
    title: '选择楼层',
    requireAuth: true
  }
},
{
  name: 'myAccount',
  component: () =>
      import('../view/user/recharge/recharge'),
  meta: {
    title: '账户余额',
    requireAuth: true
  }
},
{
  name: 'paySetting',
  component: () =>
      import('../view/user/recharge/paySetting'),
  meta: {
    title: '支付设置',
    requireAuth: true
  }
},
{
  name: 'payOrder',
  component: () =>
      import('../view/user/recharge/payOrder'),
  meta: {
    title: '支付顺序',
    requireAuth: true
  }
},
{
  name: 'payNotice',
  component: () =>
      import('../view/user/recharge/payNotice'),
  meta: {
    title: '支付通知',
    requireAuth: true
  }
},
{
  name: 'rechargeGuide',
  component: () =>
      import('../view/user/recharge/rechargeGuide'),
  meta: {
    title: '消费充值协议',
    requireAuth: true
  }
},
{
  name: 'vouchers',
  component: () =>
      import('../view/user/vouchers/vouchers'),
  meta: {
    title: '卡券管理',
    requireAuth: true
  }
},
{
  name: 'couponList',
  component: () =>
      import('../view/user/vouchers/couponList'),
  meta: {
    title: '获取卡券',
    requireAuth: true
  }
},
{
  name: 'voucherInvalid',
  component: () =>
      import('../view/user/vouchers/voucherInvalid'),
  meta: {
    title: '失效卡券',
    requireAuth: true
  }
},
{
  name: 'voucherApplication',
  component: () =>
      import('../view/user/vouchers/voucherApplication'),
  meta: {
    title: '申请卡券',
    requireAuth: true
  }
},
{
  name: 'addRecipient',
  component: () =>
      import('../view/user/vouchers/addRecipient'),
  meta: {
    title: '卡券',
    requireAuth: true
  }
},
{
  name: 'selectStaff',
  component: () =>
      import('../view/user/common/selectStaff'),
  meta: {
    title: '选择员工',
    requireAuth: true
  }
},
{
  name: 'success',
  component: () =>
      import('../view/user/common/success'),
  meta: {
    title: '成功',
    requireAuth: true
  }
},
{
  name: 'checkboxStaff',
  component: () =>
      import('../view/user/common/checkboxStaff'),
  meta: {
    title: '多选员工',
    requireAuth: true
  }
},
{
  name: 'checkboxStaffPicked',
  component: () =>
      import('../view/user/common/checkboxStaffPicked'),
  meta: {
    title: '多选员工详情',
    requireAuth: true
  }
},
{
  name: 'applySuccess',
  component: () =>
      import('../view/user/vouchers/applySuccess'),
  meta: {
    title: '申请成功',
    requireAuth: true
  }
},
{
  name: 'voucherInfo',
  component: () =>
      import('../view/user/vouchers/voucherInfo'),
  meta: {
    title: '申请详情',
    requireAuth: true
  }
},
{
  name: 'mealBook',
  component: () =>
      import('../view/user/mealBook/mealBook'),
  meta: {
    title: '消费订餐',
    requireAuth: true
  }
},
{
  name: 'mealBookForm',
  component: () =>
      import('../view/user/mealBook/mealBookForm'),
  meta: {
    title: '订餐表单',
    requireAuth: true
  }
},
{
  name: 'mealBookInfo',
  component: () =>
      import('../view/user/mealBook/mealBookInfo'),
  meta: {
    title: '订餐详情',
    requireAuth: true
  }
},
{
  name: 'showStaffList',
  component: () =>
      import('../view/user/mealBook/showStaffList'),
  meta: {
    title: '订餐详情',
    requireAuth: true
  }
},
{
  name: 'eatCode',
  component: () =>
      import('../view/user/mealBook/eatCode'),
  meta: {
    title: '订餐详情',
    requireAuth: true
  }
},
{
  name: 'expensesRecord',
  component: () =>
      import('../view/user/expensesRecord/index'),
  meta: {
    title: '消费记录',
    requireAuth: true
  }
},
{
  name: 'rechargeInfo',
  component: () =>
      import('../view/user/expensesRecord/rechargeInfo'),
  meta: {
    title: '充值记录详情',
    requireAuth: true
  }
},
{
  name: 'recordInfo',
  component: () =>
      import('../view/user/expensesRecord/recordInfo'),
  meta: {
    title: '消费记录详情',
    requireAuth: true
  }
},
{
  name: 'venueList',
  component: () =>
      import('../view/user/venueBook/venueList.vue'),
  meta: {
    title: '空间列表',
    requireAuth: true
  }
},
{
  name: 'venueInfo',
  component: () =>
      import('../view/user/venueBook/venueInfo.vue'),
  meta: {
    title: '空间详情',
    requireAuth: true
  }
}
];

// add route path
defaultRouters.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

export default [
  ...defaultRouters
];
